export default class SurveyForm {
  constructor(name,surname,city,email,phone,field,location,enterprise,question_1_selection,question_1_description,question_2_selection,question_2_description,question_3_selection,question_3_description,question_4_selection,question_4_description,question_5_selection,question_5_description,question_6_selection,question_6_description,question_7_selection,question_7_description,question_8_selection,question_8_description,question_9_selection,question_9_description,question_10_selection,question_10_description,question_11_selection,question_11_description,question_12_selection,question_12_description,question_13_selection,question_13_description,question_14_selection,question_14_description,question_15_selection,question_15_description,question_16_selection,question_16_description,question_17_selection,question_17_description) {
    this.name = name;
    this.surname = surname;
    this.city = city;
    this.email = email;
    this.phone = phone;
    this.field = field;
    this.location = location;
    this.enterprise = enterprise;
    this.question_1_selection = question_1_selection;
    this.question_1_description = question_1_description;
    this.question_2_selection = question_2_selection;
    this.question_2_description = question_2_description;
    this.question_3_selection = question_3_selection;
    this.question_3_description = question_3_description;
    this.question_4_selection = question_4_selection;
    this.question_4_description = question_4_description;
    this.question_5_selection = question_5_selection;
    this.question_5_description = question_5_description;
    this.question_6_selection = question_6_selection;
    this.question_6_description = question_6_description;
    this.question_7_selection = question_7_selection;
    this.question_7_description = question_7_description;
    this.question_8_selection = question_8_selection;
    this.question_8_description = question_8_description;
    this.question_9_selection = question_9_selection;
    this.question_9_description = question_9_description;
    this.question_10_selection = question_10_selection;
    this.question_10_description = question_10_description;
    this.question_11_selection = question_11_selection;
    this.question_11_description = question_11_description;
    this.question_12_selection = question_12_selection;
    this.question_12_description = question_12_description;
    this.question_13_selection = question_13_selection;
    this.question_13_description = question_13_description;
    this.question_14_selection = question_14_selection;
    this.question_14_description = question_14_description;
    this.question_15_selection = question_15_selection;
    this.question_15_description = question_15_description;
    this.question_16_selection = question_16_selection;
    this.question_16_description = question_16_description;
    this.question_17_selection = question_17_selection;
    this.question_17_description = question_17_description;
  }
}